interface Props {
  width?: string;
  height?: string;
  stroke?: string;
  className?: string;
}

const Clients = ({
  stroke = '#1a1818',
  width = '48',
  height = '48',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g>
      <g
        fill="none"
        stroke={stroke}
        strokeDasharray="none"
        strokeMiterlimit="10"
        strokeOpacity="1"
        strokeWidth="0.529"
        transform="translate(.17 .737)"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.306 8.34c0-1.103.84-1.997 1.875-1.997 1.035 0 1.874.894 1.874 1.998"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.281 4.026a1.1 1.1 0 11-2.201 0 1.1 1.1 0 012.201 0z"
        />
        <path
          strokeLinecap="butt"
          strokeLinejoin="miter"
          d="M6.18 9.835a4.228 4.228 0 01-4.222-4.222A4.228 4.228 0 016.18 1.39a4.227 4.227 0 014.222 4.223 4.227 4.227 0 01-4.222 4.222z"
        />
      </g>
    </g>
  </svg>
);

export default Clients;
